import React, { Component } from "react"
import intl from "react-intl-universal"
import ConsoleNav from "../../components/nav/ConsoleNav"
import { Routes, Route, Link } from 'react-router-dom'

import "./index.css"
import { consoleInit } from "../../api/console/index/Init"
import { Layout, Menu } from 'antd'
import CsIcon from "../../components/iconfont/CsIcon"
import {
    MenuUnfoldOutlined, MenuFoldOutlined
} from '@ant-design/icons'

import Combo from "./combo/Combo"
import OrderList from "./order/List"
import Pay from "./pay/Pay"
import CreateOrder from "./order/Create"
import Detail from "./order/Detail"

const { Header, Sider, Content } = Layout

const headerHeight = '48px'
const collapsedWidth = '60px'


class OrderCenter extends Component {

    contentMainRef = React.createRef();

    constructor(props) {
        super(props)
        this.state = {
            userInfo: {
                id: '',
                name: '',
                email: '',
            },
            serviceList: [],
            filterSerIdList: [],
            initDone: false,

            //
            siderWidth: '180px',
            collapsed: false,

        }

        this.toggleCollapsed = this.toggleCollapsed.bind(this)
        this.clickSiderMenu = this.clickSiderMenu.bind(this)

    }


    componentWillMount () {
        consoleInit().then((res) => {
            if (res.code === 0) {
                global.serviceInfoMap = res.data.serviceInfoMap
                global.serviceList = res.data.serviceList
                global.pjCateList = res.data.pjCateList
                global.rtmRegionList = res.data.rtmRegionList

                global.auth = {
                    // 所在公司map
                    companyMap: res.data.auth.companyMap,
                    // 所在公司ID list
                    inCompanies: res.data.auth.inCompanies,
                    // 能创建项目的公司ID list
                    canCreatePjCy: res.data.auth.canCreatePjCy,
                    // 用户中心
                    userCenterMenu: res.data.auth.userCenterMenu,
                }
                this.setState({
                    userInfo: res.data.userInfo,
                    serviceList: res.data.serviceList,
                    userMenuList: global.auth.userCenterMenu,
                    filterSerIdList: res.data.filterIdList,
                    initDone: true,
                })
            }
        }, (error) => {
            console.log("consoleInit", error.response.data)
        }
        )
    }


    // 收起/展开导航栏事件
    toggleCollapsed () {
        // console.log('this.state.collapsed true 收起',this.state.collapsed)
        if (this.state.collapsed === false) { // 收起
            this.setState({
                collapsed: true,
                siderWidth: '60px',
            })
        } else {
            this.setState({
                collapsed: false,
                siderWidth: '180px',
            })
        }
    };

    //
    clickSiderMenu (e) {
        let service = e.key
        // rtv/rta服务都属于rtm
        if (service === 15 || service === 16) {
            service = 0
        }
        this.contentMainRef?.current?.changeService?.(service)
        this.contentMainRef?.current?.changeTrendService?.(service)
    }

    render () {
        const { siderWidth, userMenuList } = this.state
        return (
            this.state.initDone &&
            <div>
                <Layout>
                    <Header style={{
                        padding: '0 0',
                        height: headerHeight,
                        lineHeight: headerHeight,
                        position: 'fixed',
                        top: 0,
                        width: '100%'
                    }}>
                        <ConsoleNav userMenuList={userMenuList}></ConsoleNav>
                    </Header>
                    <Layout hasSider style={{ position: "relative", marginTop: headerHeight }}>
                        <Sider width={siderWidth}
                            collapsible={this.state.collapsed}
                            collapsedWidth={collapsedWidth}
                            style={{
                                overflowY: 'auto',
                                height: '100%',
                                position: 'fixed',
                                left: 0,
                                top: headerHeight,
                                bottom: 0,
                                backgroundColor: '#091E42'
                            }}>


                            <Menu theme="dark" mode="inline" style={{ backgroundColor: '#091E42', paddingBottom: '120px' }}
                                defaultSelectedKeys={['order']} onClick={this.clickSiderMenu}>

                                <Menu.Item key="99" icon={<CsIcon type="line-dashboard" />} style={{ marginTop: '8px' }}>
                                    <Link to="/">{intl.get('sys.OVERVIEW')}</Link>
                                </Menu.Item>

                                <Menu.Item key="order" icon={<CsIcon type="line-payment" />} style={{ marginTop: '8px' }}>
                                    <Link to="list">
                                        <span>{intl.get('order.menu1')}</span>
                                    </Link>
                                </Menu.Item>

                                {/*<Menu.Item key="合同" icon={<CsIcon type="line-contract" />} >*/}
                                {/*    <Link to="pay">*/}
                                {/*    {this.state.collapsed == false ?*/}
                                {/*        <span>{intl.get('order.menu2')}</span> :*/}
                                {/*        <div className="collapse-title"></div>*/}
                                {/*    }*/}
                                {/*    </Link>*/}
                                {/*</Menu.Item>*/}

                                {/*<Menu.Item key="套餐" icon={<CsIcon type="line-combo" />} >*/}
                                {/*    <Link to="combo">*/}
                                {/*    {this.state.collapsed == false ?*/}
                                {/*        <span>{intl.get('order.menu3')}</span> :*/}
                                {/*        <div className="collapse-title"></div>*/}
                                {/*    }*/}
                                {/*    </Link>*/}
                                {/*</Menu.Item>*/}
                                {/*<Outlet />*/}
                            </Menu>

                            <div className="ant-layout-sider-trigger-cus" style={{ width: siderWidth }}>
                                <button className="collapse-btn" onClick={this.toggleCollapsed} style={{ marginBottom: 16 }}>
                                    {React.createElement(this.state.collapsed ? MenuUnfoldOutlined : MenuFoldOutlined)}
                                </button>
                            </div>
                        </Sider>
                        <Content style={{ marginLeft: siderWidth, overflow: 'auto', height: '100vh' }}>
                            <Routes>
                                <Route path="create" element={<CreateOrder />} />
                                <Route path="list" element={<OrderList />} />
                                <Route path="combo" element={<Combo />} />
                                <Route path="pay" element={<Pay />} />
                                <Route path="detail" element={<Detail />} />
                            </Routes>

                        </Content>
                    </Layout>
                </Layout>


            </div>
        )
    }

}


export default OrderCenter

